export const passwordReg = /^(?=.*\d{1,})(?=.*[a-zA-Z].*)(?=.*[!@#$%^&*().].*).{8,16}$/;
export const phoneReg = /^\d{11}$/;
export const appNameReg = /(^$)|(^[a-zA-Z0-9\u4e00-\u9fa5\s\-—_+:;,.!?()：；，。！？（）【】『』《》]{0,30}$)/;
export const packageNameReg = /^[a-zA-Z][0-9a-zA-Z_.]{6,126}(?<![.])$/;
export const userNameReg = /^[a-zA-Z](?=(.*[a-zA-Z]){3,})(?=(.*[\d]){1,})[0-9A-Za-z]{7,29}$/;
export const numberDotReg = /^(\d*\.\d+|\d+\.\d*)$|^(\d+\.\d+)+$/;
export const devicePluginPackageNameReg = /(^$)|(^[a-zA-Z][a-zA-Z0-9_.]{6,126}$)/; //我的设备插件包名
export const devicePluginVersionNameReg = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)$/; //我的设备版本名
export const productNameReg = /^[^%]*$/; //产品管理名
export const numberDomainReg = /\b(?:https?|ftp):\/\/(?:\d{1,3}\.)\d{1,3}\.\d{1,3}\.\d{1,3}(?::\d+)?\b/; // 纯数字域名
